<template>
  <div>
    <b-tabs content-class="mt-3" v-model="tabIndex">
      <b-tab :title="$t('curricularProducts.competence.writingLabel')">
        <div class="top-row">
          <div class="competence-type">
            <b-form-group
              v-if="competenceTypes.length > 0"
              label-cols="6"
              label-cols-sm="6"
              label-cols-lg="6"
              :label="
                $getVisibleNames(
                  'mesh.competencetype',
                  false,
                  'Tipo de Competencia'
                )
              "
              label-for="input-type"
              class="m-0"
            >
              <b-form-select
                id="input-type"
                :options="competenceTypes"
                value-field="id"
                text-field="name"
                v-model="$v.competence.type.$model"
                :state="validateCompetenceState('type')"
                :disabled="!can_edit_type && !isNaN(type_id)"
                size="sm"
                aria-describedby="input-type-feedback"
              >
                <template #first>
                  <b-form-select-option :value="null">
                    {{ $t("reusable.common.selectOption", { entity: "" }) }}
                  </b-form-select-option></template
                >
              </b-form-select>
              <b-form-invalid-feedback id="input-type-feedback">
                {{ $t("reusable.common.required") }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              v-if="egressProfileCycleSort.length > 0 && can_edit_profile_cycle"
              label-cols="6"
              label-cols-sm="6"
              label-cols-lg="6"
              :label="$getVisibleNames('mesh.cycle', false, 'Ciclo Formativo')"
              label-for="input-type"
              class="m-0"
            >
              <b-form-select
                id="input-type"
                :options="egressProfileCycleSort"
                value-field="id"
                text-field="name"
                v-model="profile_competence.cycle"
                size="sm"
                aria-describedby="input-type-feedback"
              >
                <template #first>
                  <b-form-select-option :value="null">
                    {{ $t("reusable.common.selectOption", { entity: "" }) }}
                  </b-form-select-option></template
                >
              </b-form-select>
              <b-form-invalid-feedback id="input-type-feedback">
                {{ $t("reusable.common.required") }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              v-if="egress_profile_view"
              label-cols="6"
              label-cols-sm="6"
              label-cols-lg="6"
              :label="$t('reusable.common.order')"
              label-for="input-order"
              class="m-0"
            >
              <b-form-input
                type="number"
                class="m-0 py-0"
                v-model="profile_competence.order"
                min="0"
                size="sm"
                :disabled="!can_edit_order"
                :state="orderState"
                v-b-tooltip.left.v-secondary.noninteractive="
                  !orderState
                    ? $t('curricularProducts.competence.orderTooltip', {
                        entity: $getVisibleNames(
                          'mesh.competence',
                          false,
                          'Competencia'
                        ),
                      })
                    : ''
                "
              >
              </b-form-input>
            </b-form-group>
            <b-form-group
              v-if="
                egress_profile_view &&
                institution &&
                institution.show_competence_sub_order &&
                (showCompetenceSubOrder || profile_competence.sub_order > 0)
              "
              label-cols="6"
              label-cols-sm="6"
              label-cols-lg="6"
              :label="$t('curricularProducts.competence.subOrderLabel')"
              label-for="input-order"
              class="m-0"
            >
              <b-form-input
                type="number"
                class="m-0 py-0"
                v-model="profile_competence.sub_order"
                min="1"
                size="sm"
                :disabled="!can_edit_order"
                :state="orderState"
                v-b-tooltip.left.v-secondary.noninteractive="
                  !orderState
                    ? $t('curricularProducts.competence.orderTooltip', {
                        entity: $getVisibleNames(
                          'mesh.competence',
                          false,
                          'Competencia'
                        ),
                      })
                    : ''
                "
              >
              </b-form-input>
            </b-form-group>
          </div>
          <div
            class="toggle-container"
            v-b-tooltip.v-secondary.hover.top="
              $t('curricularProducts.competence.insertOrCreateTooltip')
            "
          >
            <span :class="{ 'font-weight-bold': !checked }">{{
              $t("curricularProducts.competence.insertMode")
            }}</span>
            <b-button
              class="check-type"
              @click="changeChecked()"
              variant="primary"
            >
              <b-icon
                icon="circle-fill"
                class="icon-check"
                :class="{ 'icon-check-active': checked }"
                scale="0.7"
              ></b-icon>
            </b-button>
            <span :class="{ 'font-weight-bold': checked }">{{
              $t("curricularProducts.competence.createMode")
            }}</span>
          </div>
        </div>
        <CompetenceSentenceForm
          :key="keyRender"
          :verb="competence.verb"
          :first_content="competence.action"
          :second_content="competence.content"
          :third_content="competence.condition"
          :fourth_content="competence.context"
          :full_sentence="competence.full_sentence"
          :checked="checked"
          @update="slotUpdateSentence"
        ></CompetenceSentenceForm>
        <!-- TODO: OCULTADO TABLA CAPACIDADES -->
        <div
          v-if="
            institution &&
            institution.internal_use_id == 'duoc.cl' &&
            egress_profile_view
          "
        >
          <b-form-group
            label-cols="0"
            label-cols-sm="3"
            label-for="input-capacity"
            class="m-0 mb-2"
          >
            <template #label>
              <div class="d-flex">
                {{ $getVisibleNames("mesh.capacity", true, "Capacidades") }}
                <!-- <button
                  v-if="career && egressProfile && !egressProfile.is_closed"
                  v-can="'mesh.add_capacity'"
                  @click="openModalCapacity"
                  class="btn-add mt-0 mb-auto mr-0 ml-auto"
                  v-b-tooltip.v-secondary.noninteractive="
                    `Agregar ${$getVisibleNames(
                      'mesh.capacity',
                      true,
                      'Capacidades'
                    )}`
                  "
                >
                  <b-icon font-scale="1" icon="plus-square"></b-icon>
                </button> -->
              </div>
            </template>
            <b-form-select
              v-if="capacitiesFilter.length > 0"
              id="input-capacity"
              :options="capacitiesFilter"
              value-field="id"
              text-field="name"
              v-model="profile_competence.capacities"
              multiple
              @change="handleSelectionChange"
              :select-size="
                capacitiesFilter.length <= 5 ? capacitiesFilter.length : 5
              "
              size="sm"
            >
              <template #first>
                <b-form-select-option :value="null">
                  {{ $t("curricularProducts.competence.clearSelection") }}
                </b-form-select-option>
              </template>
            </b-form-select>
            <template v-else>
              <div class="mt-1">
                {{
                  $t("reusable.common.noCreated", {
                    entity: $getVisibleNames(
                      "mesh.capacity",
                      true,
                      "Capacidades"
                    ),
                  })
                }}
              </div>
            </template>
          </b-form-group>
        </div>
        <b-form-group
          v-if="$usesRealizationScopes(institution) && egress_profile_view"
          label-cols="0"
          label-cols-sm="3"
          label-for="input-realization-scopes"
          class="m-0 mb-2"
          :label="
            $getVisibleNames(
              'mesh.egressprofilerealizationscope',
              true,
              'Ámbitos de realización'
            )
          "
        >
          <b-form-select
            v-if="egressProfileRealizationScopes.length > 0"
            id="input-realization-scopes"
            :options="egressProfileRealizationScopes"
            value-field="id"
            text-field="name"
            v-model="profile_competence.realization_scopes"
            multiple
            :select-size="Math.min(egressProfileRealizationScopes.length, 5)"
            size="sm"
          ></b-form-select>
          <div v-else class="mt-1">
            {{
              $t("reusable.common.noCreated", {
                entity: $getVisibleNames(
                  "mesh.egressprofilerealizationscope",
                  true,
                  "Ámbitos de realización"
                ),
              })
            }}
          </div>
        </b-form-group>
        <b-form-group
          v-if="!isNaN(competence.id)"
          label-for="input-modification-date"
          label-cols="0"
          label-cols-sm="0"
          class="p-0 m-0 mt-2 mb-2"
        >
          <ModificationDate :Information="competence"></ModificationDate>
        </b-form-group>
      </b-tab>
      <b-tab
        v-if="!egress_profile_view"
        :title="
          $t('curricularProducts.competence.associateCompetence', {
            entity: $getVisibleNames('mesh.competence', false, 'Competencia'),
          })
        "
      >
        <div class="ml-2">
          <EgressProfileCompetence
            :Competence="competence"
            :egress_profile_id="egress_profile_id"
            :selected_ids="selected_ids"
            :cycle_id="cycle_id"
            :order="order"
            :can_edit_order="can_edit_order"
            :can_edit_cycle="can_edit_cycle"
            @updated="slotUpdatedProfileCompetences"
          ></EgressProfileCompetence>
        </div>
      </b-tab>
      <b-tab
        v-if="
          !isNaN(competence.id) && (egress_profile_id || !egress_profile_view)
        "
        :title="
          $t('curricularProducts.competence.associateDescriptor', {
            entity: $getVisibleNames(
              'mesh.competencedescriptor',
              false,
              'descriptor de la Competencia'
            ),
          })
        "
      >
        <CompetenceDescriptors
          :competence_id="competence.id"
          :egress_profile_id="egress_profile_id"
          :allows_crud="allows_crud"
          :can_update="can_update"
          :can_delete="can_delete"
          :show_visible="egress_profile_view"
          @reset_competence="() => this.$emit('reset_competence')"
          @change_middle_descriptors="
            (value) => this.$emit('change_middle_descriptors', value)
          "
          @reset_competence_table="() => this.$emit('reset_competence_table')"
        >
        </CompetenceDescriptors>
      </b-tab>
    </b-tabs>
    <b-modal
      :id="`new-capacity-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames('mesh.capacity', true, 'Capacidades'),
        })
      "
      size="md"
    >
      <CapacityForm
        v-if="career"
        :faculty_id="career.faculty"
        @created="slotCreatedCapacity"
      ></CapacityForm>
    </b-modal>
    <div class="row">
      <div v-if="show_delete_button" class="col" style="text-align: left">
        <b-button
          v-if="!isNaN(profile_competence.id)"
          variant="danger"
          class="mr-1"
          size="sm"
          @click="askDeleteProfileCompetence(profile_competence.id)"
          :disabled="isNaN(competence.id)"
          v-bind:style="{
            cursor: !isNaN(competence.id) ? 'pointer' : 'not-allowed',
          }"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div class="col" style="text-align: right">
        <template v-if="!isNaN(competence.id)">
          <!-- class="modal-base-ra" -->
          <b-button
            @click="$bvModal.show(`modal-base-ra`)"
            class="mr-2"
            size="sm"
            v-if="institution && institution.show_base_ra"
          >
            {{ $getVisibleNames("teaching.basera", false, "RA Base") }}
            <b-badge
              v-if="raBasesFiltered"
              class="ra-bases-badge"
              variant="light"
              >{{ raBasesFiltered.length }}</b-badge
            >
          </b-button>
          <b-modal
            :id="`modal-base-ra`"
            hide-footer
            :title="$getVisibleNames('teaching.basera', false, 'RA Base')"
            size="lg"
          >
            <RaBase :competence_id="competence.id"></RaBase>
          </b-modal>
        </template>
        <b-button
          class="mr-1"
          size="sm"
          @click="saveCompetence"
          :disabled="!valid_competence"
          v-bind:style="{
            cursor: valid_competence ? 'pointer' : 'not-allowed',
          }"
          :variant="valid_competence ? 'secondary' : 'light'"
          >{{ $t("reusable.common.save") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { generateUniqueId } from "@/utils/utils";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { toast } from "@/utils/utils";
import { scopesOfEgressProfile } from "@/utils/realizationScopes";

export default {
  name: "CompetenceForm",
  mixins: [validationMixin],
  components: {
    CompetenceDescriptors: () => import("./CompetenceDescriptors"),
    CompetenceSentenceForm: () =>
      import("@/components/reusable/CompetenceSentenceForm"),
    RaBase: () => import("@/components/reusable/RaBase"),
    EgressProfileCompetence: () =>
      import("@/components/mesh/EgressProfile/EgressProfileCompetence"),
    CapacityForm: () => import("@/components/mesh/Capacities/CapacityForm"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
  },
  props: {
    Competence: {
      type: Object,
    },
    egress_profile_id: {
      type: Number,
    },
    type_id: {
      type: Number,
      default: null,
    },
    cycle_id: {
      type: Number,
    },
    order: {
      type: Number,
      default: 1,
    },
    sub_order: {
      type: Number,
      default: 0,
    },
    can_edit_type: {
      type: Boolean,
      default: true,
    },
    can_edit_cycle: {
      type: Boolean,
      default: true,
    },
    can_edit_profile_cycle: {
      type: Boolean,
      default: false,
    },
    can_edit_order: {
      type: Boolean,
      default: true,
    },
    allows_crud: {
      type: Boolean,
      default: true,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
    show_delete_button: {
      type: Boolean,
      default: true,
    },
    egress_profile_view: {
      type: Boolean,
      default: false,
    },
    show_cycle: {
      type: Boolean,
      default: true,
    },
    selected_ids: {
      type: Array,
      default: function () {
        return [];
      },
    },
    matrix1_competence: {
      type: Boolean,
    },
  },
  data() {
    return {
      competence: {
        id: this.Competence ? this.Competence.id : generateUniqueId(),
        verb: this.Competence ? this.Competence.verb : null,
        action: this.Competence ? this.Competence.action : "",
        content: this.Competence ? this.Competence.content : "",
        condition: this.Competence ? this.Competence.condition : "",
        context: this.Competence ? this.Competence.context : "",
        full_sentence: this.Competence ? this.Competence.full_sentence : "",
        type: this.Competence ? this.Competence.type : this.type_id,
        updated_by: this.Competence ? this.Competence.updated_by : null,
        update_date: this.Competence ? this.Competence.update_date : null,
      },
      profile_competence: {
        id: generateUniqueId(),
        egress_profile: this.egress_profile_id ? this.egress_profile_id : null,
        cycle: this.cycle_id ? this.cycle_id : null,
        capacities: [],
        realization_scopes: [],
        order: this.order ? this.order : 1,
        sub_order: this.sub_order ? this.sub_order : 0,
        competence: this.Competence ? this.Competence.id : null,
      },
      tabIndex: 0,
      valid_competence: false,
      egress_profile_competences: [],
      checked:
        this.Competence &&
        this.Competence.content.length > 0 &&
        this.Competence.condition.length > 0 &&
        this.Competence.context.length > 0
          ? true
          : false,
      keyRender: 0,
    };
  },
  validations() {
    if (this.checked)
      return {
        competence: {
          action: { required },
          content: { required },
          condition: { required },
          context: { required },
          full_sentence: {},
          type: {},
        },
      };
    else
      return {
        competence: {
          action: {},
          content: {},
          condition: {},
          context: {},
          full_sentence: { required },
          type: {},
        },
      };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      cycles: names.CYCLES,
      competenceTypes: names.COMPETENCE_TYPES,
      egressProfiles: names.EGRESS_PROFILES,
      faculties: names.FACULTIES,
      profileCompetences: names.PROFILE_COMPETENCES,
      capacities: names.CAPACITIES,
      realization_scopes: names.REALIZATION_SCOPES,
      careers: names.CAREERS,
      profile_cycles: names.PROFILE_CYCLES,
      ra_bases: names.RA_BASES,
    }),
    raBasesFiltered() {
      if (!this.competence.id) return;
      return this.ra_bases.filter((x) =>
        x.competences.includes(this.competence.id)
      );
    },
    egressProfile() {
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    egressProfileRealizationScopes() {
      return scopesOfEgressProfile(
        this.realization_scopes,
        this.egress_profile_id
      );
    },
    capacitiesFilter() {
      if (!this.career) return [];
      return this.capacities.filter(
        (x) =>
          x.faculties.includes(this.career.faculty) ||
          this.profile_competence.capacities.includes(x.id) ||
          x.is_global === true
      );
    },
    egressProfileCycleId() {
      if (!this.egress_profile_id) return [];
      let list = [];
      this.profile_cycles.forEach((x) => {
        if (x.egress_profile == this.egress_profile_id) list.push(x.cycle);
      });
      return list;
    },
    egressProfileCycleSort() {
      if (!this.egressProfile) return [];
      let cycles = this.cycles.filter((x) =>
        this.egressProfileCycleId.includes(x.id)
      );
      cycles.forEach((x) => {
        let cycle_list = this.profile_cycles.find(
          (profile_cycle) =>
            profile_cycle.cycle == x.id &&
            profile_cycle.egress_profile == this.egress_profile_id
        );
        if (cycle_list) {
          x.init_semester = cycle_list.init_semester;
          x.end_semester = cycle_list.end_semester;
          x.order = cycle_list.order;
        }
      });
      return cycles.sort(function (a, b) {
        if (a.init_semester < b.init_semester) return -1;
        if (a.init_semester > b.init_semester) return 1;
        if (a.end_semester < b.end_semester) return -1;
        if (a.end_semester > b.end_semester) return 1;
        return 0;
      });
    },
    showCompetenceSubOrder() {
      return (
        this.profileCompetences.filter(
          (x) =>
            x.egress_profile == this.egress_profile_id &&
            x.order == this.profile_competence.order &&
            x.cycle == this.cycle_id &&
            x.id != this.profile_competence.id
        ).length > 0
      );
    },
    orderState() {
      if (this.egress_profile_id && this.egress_profile_view) {
        const profile_competence = this.profileCompetences.filter(
          (x) =>
            x.egress_profile == this.egress_profile_id &&
            x.order == this.profile_competence.order &&
            x.sub_order == this.profile_competence.sub_order &&
            x.cycle == this.cycle_id &&
            x.id != this.profile_competence.id
        );
        if (profile_competence.length > 0) {
          return false;
        }
      }
      return true;
    },
  },
  watch: {
    // Clearing the input leaves "" which the backend rejects ("A valid integer
    // is required"); 0 means "no sub-order" and also hides the field.
    "profile_competence.sub_order"(value) {
      const parsed = parseInt(value, 10);
      if (isNaN(parsed) || parsed < 0) this.profile_competence.sub_order = 0;
    },
  },
  methods: {
    validateCompetenceState(atr) {
      const { $dirty, $error } = this.$v.competence[atr];
      return $dirty ? !$error : null;
    },
    saveCompetence() {
      this.$v.competence.$touch();
      if (this.$v.competence.$anyError) return;
      if (this.checked) {
        this.competence.full_sentence = String(
          this.competence.action +
            " " +
            this.competence.content +
            " " +
            this.competence.condition +
            " " +
            this.competence.context
        );
        if (isNaN(this.competence.id)) this.createCompetence();
        else this.updateCompetence();
      } else {
        if (
          this.competence.full_sentence &&
          this.competence.full_sentence.trim() !== ""
        ) {
          // Clear individual fields so reload defaults to "insertar" mode
          this.competence.action = this.competence.full_sentence
            .trim()
            .split(" ")
            .shift();
          this.competence.content = "";
          this.competence.condition = "";
          this.competence.context = "";
          this.keyRender += 1;
          if (isNaN(this.competence.id)) this.createCompetence();
          else this.updateCompetence();
        }
      }
    },
    createCompetence() {
      this.$store
        .dispatch(names.POST_COMPETENCE, this.competence)
        .then((response) => {
          this.competence = { ...response };
          this.profile_competence.competence = response.id;
          toast(
            String(
              this.$getVisibleNames("mesh.competence", false, "Competencia") +
                " " +
                this.$t("reusable.common.created")
            )
          );
          this.saveProfileCompetences();
          setTimeout(() => {
            this.tabIndex = 2;
          }, 500);
          // this.$emit("created", this.competence);
        });
    },
    updateCompetence() {
      this.$store
        .dispatch(names.UPDATE_COMPETENCE, this.competence)
        .then((response) => {
          this.competence = { ...response };
          toast(
            String(
              this.$getVisibleNames("mesh.competence", false, "Competencia") +
                " " +
                this.$t("reusable.common.updated")
            )
          );
          this.saveProfileCompetences();
          this.$emit("created", this.competence);
          this.$emit("updated", this.competence);
        });
    },
    deleteCompetence() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.competence",
            false,
            "Competencia"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_COMPETENCE, this.competence.id)
            .then(() => {
              toast(
                String(
                  this.$getVisibleNames(
                    "mesh.competence",
                    false,
                    "Competencia"
                  ) +
                    " " +
                    this.$t("reusable.common.deleted")
                )
              );
            });
        }
      });
    },
    saveProfileCompetences() {
      if (this.egress_profile_view) {
        if (!this.profile_competence.id || isNaN(this.profile_competence.id))
          this.createProfileCompetence(this.profile_competence);
        else this.updateProfileCompetence(this.profile_competence);
      } else {
        this.egress_profile_competences.forEach((egress_profile_competence) => {
          if (egress_profile_competence.selected) {
            if (
              !egress_profile_competence.id ||
              isNaN(egress_profile_competence.id)
            ) {
              this.createProfileCompetence(egress_profile_competence);
            } else {
              this.updateProfileCompetence(egress_profile_competence);
              // TODO: Garantizar de alguna forma que el objeto no se actualice si no ha sido moficado.
            }
          } else {
            if (
              egress_profile_competence.id &&
              !isNaN(egress_profile_competence.id)
            ) {
              this.deleteProfileCompetence(egress_profile_competence.id);
            }
          }
        });
      }
    },
    createProfileCompetence(profile_competence) {
      const payload = {
        order: profile_competence.order,
        sub_order: profile_competence.sub_order,
        egress_profile: profile_competence.egress_profile,
        capacities: profile_competence.capacities
          ? profile_competence.capacities
          : [],
        realization_scopes: profile_competence.realization_scopes
          ? profile_competence.realization_scopes
          : [],
        competence: this.competence.id,
        cycle: profile_competence.cycle,
      };
      this.$store
        .dispatch(names.POST_PROFILE_COMPETENCE, payload)
        .then((response) => {
          this.profile_competence = response;
          toast(
            this.$t("curricularProducts.competence.relationshipCreated", {
              entity1: this.$getVisibleNames(
                "mesh.egressprofile",
                false,
                "Perfil de Egreso"
              ),
              entity2: this.$getVisibleNames(
                "mesh.competence",
                false,
                "Competencia"
              ),
            })
          );
          this.$emit("created_egress_profile_competence", response);
          this.$emit("close", this.competence.id);
        });
    },
    updateProfileCompetence(profile_competence) {
      this.$store
        .dispatch(names.UPDATE_PROFILE_COMPETENCE, profile_competence)
        .then((response) => {
          this.profile_competence = response;
          toast(
            this.$t("curricularProducts.competence.relationshipUpdated", {
              entity1: this.$getVisibleNames(
                "mesh.egressprofile",
                false,
                "Perfil de Egreso"
              ),
              entity2: this.$getVisibleNames(
                "mesh.competence",
                false,
                "Competencia"
              ),
            })
          );
          this.$emit("updated_egress_profile_competence", profile_competence);
          this.$emit("close", this.competence.id);
        });
    },
    askDeleteProfileCompetence(egress_profile_competence_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.competence",
            false,
            "Competencia"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.deleteProfileCompetence(egress_profile_competence_id);
          this.$emit("deleted");
        }
      });
    },
    deleteProfileCompetence(egress_profile_competence_id) {
      if (isNaN(egress_profile_competence_id) || !egress_profile_competence_id)
        return;
      this.$store
        .dispatch(names.DELETE_PROFILE_COMPETENCE, egress_profile_competence_id)
        .then(() => {
          toast(
            this.$t("curricularProducts.competence.deletedFromProfile", {
              entity: this.$getVisibleNames(
                "mesh.competence",
                false,
                "Competencia"
              ),
              profile: this.$getVisibleNames(
                "mesh.egressprofile",
                false,
                "Perfil de Egreso"
              ),
            })
          );
          this.$emit("close", this.competence.id);
        });
    },
    handleSelectionChange() {
      if (this.profile_competence.capacities.includes(null)) {
        this.profile_competence.capacities = []; // Limpia todas las selecciones
      }
    },
    slotUpdateSentence(sentence) {
      // TODO: Revisar porque se ejecuta sin que haya cambiado nada.
      this.competence.action = sentence.first_content;
      this.competence.verb = sentence.verb;
      this.competence.content = sentence.second_content;
      this.competence.condition = sentence.third_content;
      this.competence.context = sentence.fourth_content;
      this.competence.full_sentence = sentence.full_sentence;
    },
    slotUpdatedProfileCompetences(egress_profile_competences) {
      this.egress_profile_competences = egress_profile_competences;
    },
    changeChecked() {
      this.checked = !this.checked;
      this.keyRender += 1;
      if (isNaN(this.competence.id)) {
        if (this.user && this.user.user_data) {
          this.$restful
            .Patch(`/authentication/user-data/${this.user.user_data.id}/`, {
              base_sentence_create: this.checked,
            })
            .then((resposne) => {
              this.user.user_data = resposne;
              this.$store.commit("setUser", this.user);
            });
        } else {
          this.$restful
            .Post(`/authentication/user-data/`, {
              user: this.user.id,
              identifier_type: null,
              address: null,
              identifier: "",
              phone_1: "",
              phone_2: "",
              alternative_email: "",
              font_size: 20,
              creation_email_sent: false,
              image: null,
              base_sentence_create: this.checked,
            })
            .then((resposne) => {
              this.user.user_data = resposne;
              this.$store.commit("setUser", this.user);
            });
        }
      }
    },
    openModalCapacity() {
      if (this.faculties.length == 0)
        this.$store.dispatch(names.FETCH_FACULTIES);
      this.$bvModal.show(`new-capacity-modal`);
    },
    slotCreatedCapacity(response) {
      this.$nextTick(() => {
        this.profile_competence.capacities.push(response.id);
        this.$bvModal.hide("new-capacity-modal");
      });
    },
  },
  mounted() {
    if (isNaN(this.competence.id) && this.user && this.user.user_data) {
      this.checked = this.user.user_data.base_sentence_create;
    }
  },
  created() {
    this.$store.dispatch(names.FETCH_COMPETENCE_TYPES);
    this.$store.dispatch(names.FETCH_CYCLES);
    // Solo pedir el perfil de egreso específico si se conoce su id, en lugar de todos
    if (this.egress_profile_id) {
      this.$store.dispatch(names.FETCH_EGRESS_PROFILE, this.egress_profile_id);
    }
    // Construir payload filtrado para evitar pedir todos los profile_competences
    if (
      this.egress_profile_id ||
      (this.Competence && !isNaN(this.Competence.id))
    ) {
      const search_payload = {};
      if (this.egress_profile_id)
        search_payload.egress_profile_id = this.egress_profile_id;
      if (this.Competence && !isNaN(this.Competence.id))
        search_payload.competence_id = this.Competence.id;
      this.$store
        .dispatch(names.FETCH_PROFILE_COMPETENCES, search_payload)
        .then((response) => {
          if (this.Competence) {
            const profileCompetence = response.find(
              (x) =>
                x.competence == this.Competence.id &&
                x.egress_profile == this.egress_profile_id &&
                x.cycle == this.cycle_id
            );
            if (profileCompetence) {
              this.profile_competence.id = profileCompetence.id;
              this.profile_competence.order = profileCompetence.order;
              this.profile_competence.sub_order = profileCompetence.sub_order;
              this.profile_competence.capacities = profileCompetence.capacities;
              this.profile_competence.realization_scopes =
                profileCompetence.realization_scopes || [];
              profileCompetence.capacities.forEach((capacity_id) => {
                this.$store.dispatch(names.FETCH_CAPACITY, capacity_id);
              });
            }
          }
        });
    }
    if (!isNaN(this.competence.id))
      this.$store.dispatch(names.FETCH_RA_BASES, {
        competence_id: this.competence.id,
      });
  },
  updated() {
    // this.$v.competence.$touch();
    this.valid_competence = !this.$v.competence.$anyError;
  },
};
</script>

<style scoped>
.top-row {
  width: 100%;
  display: flex;
}
.btn-add {
  border: none;
  background: transparent;
  font-size: 13pt;
  padding: 0;
}
.competence-type {
  width: 50%;
}
.toggle-container {
  width: 50%;
  padding-left: 6.6em;
  padding-top: 0.6em;
}
.check-type {
  background: #007bff !important;
  margin-inline: 0.7em;
  height: 1.1em;
  width: 2.2em !important;
  margin-top: 0.1em;
  border-radius: 10px;
}
.icon-check {
  color: white;
  transform: translate(-70%, -52%);
  transition: 0.2s;
}
.icon-check-active {
  transform: translate(15%, -52%) !important;
}
/* .modal-base-ra {
  display: flex;
  margin-right: 0;
  margin-left: auto;
} */
.ra-bases-badge {
  margin: 0.2rem;
  margin-left: 0.5rem;
  vertical-align: middle;
}
@media (max-width: 991px) {
  .competence-type {
    width: 62%;
  }

  .toggle-container {
    width: 38%;
    padding-left: 1em;
  }
}
</style>